var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9461 8.00016C28.9194 8.46683 27.8127 8.7735 26.6661 8.92016C27.8394 8.2135 28.7461 7.0935 29.1727 5.74683C28.0661 6.4135 26.8394 6.88016 25.5461 7.14683C24.4927 6.00016 23.0127 5.3335 21.3327 5.3335C18.1994 5.3335 15.6394 7.8935 15.6394 11.0535C15.6394 11.5068 15.6927 11.9468 15.7861 12.3602C11.0394 12.1202 6.81273 9.84016 3.9994 6.38683C3.50607 7.22683 3.22607 8.2135 3.22607 9.2535C3.22607 11.2402 4.22607 13.0002 5.77273 14.0002C4.82607 14.0002 3.94607 13.7335 3.17273 13.3335C3.17273 13.3335 3.17273 13.3335 3.17273 13.3735C3.17273 16.1468 5.14607 18.4668 7.7594 18.9868C7.2794 19.1202 6.77273 19.1868 6.25273 19.1868C5.89273 19.1868 5.53273 19.1468 5.18607 19.0802C5.90607 21.3335 7.9994 23.0135 10.5194 23.0535C8.57273 24.6002 6.10607 25.5068 3.41273 25.5068C2.9594 25.5068 2.50607 25.4802 2.05273 25.4268C4.58607 27.0535 7.5994 28.0002 10.8261 28.0002C21.3327 28.0002 27.1061 19.2802 27.1061 11.7202C27.1061 11.4668 27.1061 11.2268 27.0927 10.9735C28.2127 10.1735 29.1727 9.16016 29.9461 8.00016Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4b644f3f205472a9a84070df5d8537d9.svg";
export { ForwardRef as ReactComponent };